import { GoArrowLeft } from "react-icons/go";
import {
  ContactListType,
} from "utils/interfaces";
import { motion } from "framer-motion";
import UserCardsList from "../common/UserCardsList";

interface ViewTeacherListProps {
  selectedTeachers: ContactListType[];
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const variantsItems = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1 },
  exit: {
    opacity: 0,
    scale: 0.9,
    transition: { duration: 0.1, ease: "easeOut" },
  },
};

const ViewTeacherList: React.FC<ViewTeacherListProps> = ({
  selectedTeachers,
  setShowPopUp,
}) => {
  /**
   * Definition of the function when pressed back button
   */
  const handlePressBack = () => {
    // This pop up is being used by itself, so just close it
    setShowPopUp(false);
  };

  return (
    <>
      <motion.div
        key="view-teacher-list-blurred-background"
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={() => setShowPopUp(false)}
      />
      <motion.div
        key="view-teacher-panel"
        variants={variantsItems}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        className="fixed w-[462px] h-fit max-h-[90%] left-0 right-0 ml-auto mr-auto px-6 pt-6 pb-8 bottom-5 bg-white rounded-3xl flex-col justify-start items-start gap-6 inline-flex z-30"
      >
        <div className="relative w-full h-fit max-h-[80vh] flex-col justify-start items-start gap-6 inline-flex">
          <div className="self-stretch justify-start items-center gap-3 flex">
            <button
              className="p-1.5 bg-neutral-50 rounded-full backdrop-blur-[32px] justify-center items-center flex cursor-pointer hover:bg-neutral-100 ease-in-out duration-150"
              onClick={handlePressBack}
              title="Come back to the previous step"
            >
              <GoArrowLeft className="w-5 h-5 fill-secondary-600" />
            </button>
            <div className="text-neutral-600 text-lg font-normal font-sans leading-snug select-none">
              Staff assigned to this class
            </div>
          </div>
          <UserCardsList
            key="view-teacher-list"
            userList={selectedTeachers}
            selectedUsers={selectedTeachers as ContactListType[]}
            isLoadingData={false}
            primaryTags={false}
            justDisplay={true}
            selectAction={() => {}}
          />
        </div>
      </motion.div>
    </>
  );
};

export default ViewTeacherList;
